import { render, staticRenderFns } from "./SGPFacePersonPicker.vue?vue&type=template&id=a3c43ad8"
import script from "./SGPFacePersonPicker.vue?vue&type=script&lang=js"
export * from "./SGPFacePersonPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports